const DELIVERY_HAS_CANCELLATION = "DELIVERY_HAS_CANCELLATION";
const DELIVERY_HAS_CANCELLATION_SUCCESS = "DELIVERY_HAS_CANCELLATION_SUCCESS";
const DELIVERY_HAS_CANCELLATION_FAILURE = "DELIVERY_HAS_CANCELLATION_FAILURE";
const CLEAR_DELIVERY_HAS_CANCELLATION = "CLEAR_DELIVERY_HAS_CANCELLATION";

const DeliveryHasCancellation = {
  DELIVERY_HAS_CANCELLATION_SUCCESS,
  DELIVERY_HAS_CANCELLATION_FAILURE,
  DELIVERY_HAS_CANCELLATION,
  CLEAR_DELIVERY_HAS_CANCELLATION,
};
export default DeliveryHasCancellation;
